import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../../../common/queryClient/getMutationFn';
import { UserBookmarkUrl } from './UserBookmarkUrl';

import { UserBookmarkFormDataType } from '../schema/types';

const postUserBookmarks = (userBookmarks: UserBookmarkFormDataType[]) =>
  apiClient
    .post<UserBookmarkFormDataType>(expand(UserBookmarkUrl.list), userBookmarks)
    .then((response) => response.data);

export const useMutateUserBookmarksQuery = createApiMutationHook(
  ['user-bookmark-list'],
  getMutationFn(postUserBookmarks, undefined, undefined),
);
